import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=063e4ad2&scoped=true&"
import script from "./user-agreement.vue?vue&type=script&lang=ts&"
export * from "./user-agreement.vue?vue&type=script&lang=ts&"
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=063e4ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e4ad2",
  null
  
)

export default component.exports